/* eslint-disable camelcase */
import { db, firebase } from './firebase'
import snapshotParser from '../helpers/snapshotparser'

const getRandom = (bottom, top) => Math.floor(Math.random() * (1 + top - bottom)) + bottom

export const getList = async (period) => {
  const snap = await db.collection(`Ordenes/Pedidos/${period}`).orderBy('date', 'desc').get()
  const list = snapshotParser(snap)
  return list.filter(item => item.status)
}

export const setViewed = async ({ id, period }) => {
  try {
    await db.doc(`Ordenes/Pedidos/${period}/${id}`).update({ isViewed: true })
    await db.doc('Ordenes/Pedidos').update({
      counter: firebase.firestore.FieldValue.increment(-1)
    })
    return true
  } catch (error) {
    console.error('error_description:', error)
    return false
  }
}

export const changeStatus = async ({ status, id, period }) => {
  try {
    await db.doc(`/Ordenes/Pedidos/${period}/${id}`).update({ status })
    return true
  } catch (error) {
    console.error('error_description:', error)
    return false
  }
}

export const onCounterChange = handler => {
  const unsubscribe = db.doc('Ordenes/Pedidos').onSnapshot(snap => {
    const data = snapshotParser(snap)
    handler(data ? data.counter : 0)
  })
  return unsubscribe
}

export const create = async ({ tax = '', email, name, lastname, street_number = null, suburb = null, city = null, state = null, postal_code = null, number = null, subTotal = null, discountPercentage = 0, shipping = null, totalPrice = null, methodPay, itemsOncart, date: date_ }) => {
  const random = getRandom(1, 99)
  const order_id = Date.now()
  const trimmed = parseInt(`${random}${(order_id).toString().slice(2)}`)

  try {
    const items = itemsOncart.map(item => {
      const { id, price, quantity, sku, title, picture } = item
      return { id, price, quantity, sku, title, picture }
    })
    const date = new Date()
    const period = `${date.getMonth() + 1}-${date.getFullYear()}`
    const objectToSsave = {
      isViewed: false,
      items,
      subTotal,
      shipping,
      discountPercentage,
      discountAmount: subTotal * discountPercentage,
      mailCost: shipping,
      totalPrice,
      date,
      methodPay,
      tax,
      user: { email, name, lastname, number },
      order_id: trimmed,
      birthdate: date_
    }

    if (street_number || suburb || city || state || postal_code) objectToSsave.shipTo = { street_number, suburb, city, state, postal_code }

    const result = await db.collection(`Ordenes/Pedidos/${period}`).add(objectToSsave)
    await db.doc(`Ordenes/Pedidos/${period}/${result.id}`).update({ id: result.id })
    return { id: result.id, path: result.path, order_id: trimmed }
  } catch (error) {
    console.error('error_description:', error)
    return false
  }
}

export const success = async ({ id, status = 'pending', meta = {}, notific = null }) => {
  try {
    const date = new Date()
    const period = `${date.getMonth() + 1}-${date.getFullYear()}`
    await db.doc(`Ordenes/Pedidos/${period}/${id}`).update({ status: 'pending', meta })
    if (notific) {
      try {
        await db.doc('Ordenes/Pedidos').update({ counter: firebase.firestore.FieldValue.increment(1) })
      } catch (error) {
        await db.doc('Ordenes/Pedidos').set({ counter: firebase.firestore.FieldValue.increment(1) })
      }
    }
    return true
  } catch (error) {
    console.error('error_description:', error)
    return false
  }
}

export const failed = async id => {
  try {
    const date = new Date()
    const period = `${date.getMonth() + 1}-${date.getFullYear()}`
    await db.doc(`Ordenes/Pedidos/${period}/${id}`).delete()
  } catch (error) {
    console.error('error_description:', error)
    return false
  }
}

export default {
  getList,
  changeStatus,
  onCounterChange,
  setViewed,
  create,
  success,
  failed
}
